import { initNewRelic } from "./newrelic/newrelic_loader";
import './polyfills';
import React from "react";
import { createRoot } from "react-dom/client";
import { IIRISTargetType } from "./widgets/target-type";


const widgets = document.querySelectorAll(".iiris-target");

Array.prototype.forEach.call(widgets, async function (widget) {
  const prop: any = {
    config: {},
  };
  [
    "division",
    "recipe",
    "variant",
    "mode",
    "itemUrl",
    "totalCards",
    "scrollPosition",
    "widgetType",
    "category",
    "author",
    "content_type",
    "defaultRuleEnabled",
    "itemType",
    "itemValue",

    // Common,
    "skin",
    "brand_family",
    "brand",
    "cardWidth",
    "title",
    "subTitle",
    "limit",
    "cards",
    "dateFormat",
    "redirectMode",
    "layout",
    "showEntityTag",
    "showDate",
    "showCardBgIcon",
    "entityImagePosition",
    "scrollInterval",
    "entityTagFont",
    "entityTagBackground",
    "scrollType",
    "imageIcon",
    "imageIconColor",
    "placement",
    "id",
    "mobilePreview",
    "uploadHtml",
    "htmlContent",

    // ** BANNER ** //
    "widgetsize",
    "showBorder",
    "borderColor",
    "showBy",
    "showTime",
    "campaignId",
    "bannerId",
    "advertiserId",
    "targetUrl",
    "imageUrl",
    "rule",
    "issticky",
    "widgetposition",
    "userid",
    "media",
    "mediaPosition",
    "hascontent",
    "fontSize1",
    "fontSize2",
    "bannerTitle",
    "bannerDescription",
    "poster",
    "cookieChoice",

    // ** POPUP ** //
    "actionLabel",
    "description",
    "popupTitle",
    "backgroundColor",
    "fontColor",
    "showActionLabel",
    "actionLabelBackground",
    "cookieName",
    "leftMargin",
    "bottomMargin",
    "topMargin",
    "rightMargin",
    "actionLabelFont",
    "animate",
    "timeDelay",
    "daysToShow",
    "buttonTopMargin",
    "buttonRightMargin",
    "showbuttonBorder",
    "borderSize",
    "buttonSize",
    "buttonColor",
    "buttonBorderColor",
    "buttonFill",
    "mobileViewImageUrl",
    "desktopwidgetsize",
    "mobilewidgetsize",
    "desktopscreen",
    "mobilescreen",
    "widgetwidth",
    "widgetheight",
    "utmparam",

    // ** PAGE ** //
    "pageUrl",
    "adminCenter",
    "configId",
    "endDate",
    "startDate",
    "env",
    "filterValue",
    "isEntitled",
    "mode",
    "experiments",
    "experimentState",
  ].forEach((id) => {
    prop.config[id] =
      typeof widget.getAttribute(id) !== "undefined" && widget.getAttribute(id)
        ? widget.getAttribute(id)
        : "";
  });

    if (prop.config.configId) {
      initNewRelic();
      const apiUrl = `${import.meta.env.VITE_ADMIN_API_BASE_URL}/public/config/item/${prop.config.configId}`;
    
      try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      const widgetConfig = {
        ...(data.config?.data_config?.apiType?.recommend || {}),
        ...(data.config?.ui_config?.widgettypes?.banner || {}),
        ...(data.config?.ui_config?.widgettypes?.popupv2 || {}),
        widgetType: data.config?.ui_config?.defaultType || "",
        domain: data.brand.domain
          .replaceAll("/", "")
          .split(".")
          .slice(-2)
          .join("."),
      };

      delete widgetConfig["userid"];
      prop.config = { ...prop.config, ...widgetConfig };
    } catch (error) {
      console.error("Error fetching widget config:", error);
    }
  }

  const root = createRoot(widget);

  root.render((<IIRISTargetType {...prop} />) as React.ReactElement);
});

declare global {
  interface Window {
    IIRISTracker?: any;
  }
}